import React from 'react';
import './copy.scss';
import { getQuery } from '../../utils/browser';
import { getFdsPath } from '../../utils/api';
import { Toast } from 'antd-mobile';

export default function Copy() {
    let model = getQuery('model');
    let locale = getQuery("locale");
    let type = getQuery("type");
    // let urlPath = window.location.host;
    let input = React.createRef()
    let copyText = () => {
        let text;
        if (type === 'watch_privacy_policy') {
            if (model === 'app' || model === 'app_lite') {
                text = getFdsPath(`/pdf/${locale}/app.pdf`)
            } else if (model === 'mj1205.motion.ecg') {
                text = getFdsPath(`/pdf/${locale}/mj1205.motion.ecg.pdf`)
            } else if (model === 'xiaomi.watch.mars') {
                text = getFdsPath(`/pdf/${locale}/xiaomi.watch.mars.pdf`)
            } else if (model === 'hmpace.motion.v6' || model === 'hmpace.motion.v6nfc') {
                text = getFdsPath(`/pdf/${locale}/hmpace.motion.v6.pdf`)
            } else if (model === 'ksmb.treadmill.m1v1') {
                text = getFdsPath(`/pdf/${locale}/ksmb.treadmill.m1v1.pdf`)
            } else if (model === 'hmpace.bracelet.v5' || model === 'hmpace.bracelet.v5h') {
                text = getFdsPath(`/pdf/${locale}/hmpace.bracelet.v5.pdf`)
            } else {
                text = getFdsPath(`/pdf/${locale}/watch.pdf`)
            }
        } else {
            text = getFdsPath(`/pdf/${locale}/${type}.pdf`)
        }

        input.current.value = text; // 修改文本框的内容
        input.current.select(); // 选中文本
        document.execCommand("copy"); // 执行浏览器复制命令
        document.activeElement.blur();
        Toast.info('复制成功！')
    }

    if (type === 'watch_user_privacy') {
        type = "watch_privacy_policy"
    }
    if (locale) {
        locale = locale.toLowerCase()
    }
    const ruleLink = (locale === 'zh_cn') /*&& (urlPath === 'watch.iot.mi.com' || urlPath === 'localhost:3007')*/
        && (type === "watch_privacy_policy"
            || type === 'user_sensitive_info' || type === 'user_sensitive_info_v3'
            || type === 'sport_healthy_privacy' || type === 'earphone_privacy_policy')
    if (ruleLink) {
        return (
            <div>
                <textarea ref={input} id="input"></textarea>
                <button onClick={copyText}>点击复制下载链接</button>
            </div>
        )
    } else return null
}
